import {
  AnimatePresence,
  type MotionNodeAnimationOptions,
  motion,
} from "motion/react";
import { Trans } from "react-i18next";
import { CalculatorAside } from "../../components/calculator-aside/CalculatorAside";
import { CalculatorCustom } from "../../components/calculator-custom/CalculatorCustom";
import { CalculatorDialogs } from "../../components/calculator-dialogs/CalculatorDialogs";
import { CalculatorPack } from "../../components/calculator-pack/CalculatorPack";
import { CalculatorPaymentBtn } from "../../components/calculator-payment-btn/CalculatorPaymentBtn";
import { CalculatorPeriod } from "../../components/calculator-period/CalculatorPeriod";
import { useCalculator } from "../../hooks/useCalculator";
import styles from "./CalculatorCustomPack.module.css";

export const CalculatorCustomPack = () => {
  const isCustomActive = useCalculator((state) => state.isCustomActive);

  return (
    <>
      <div className={styles.layout}>
        <AnimatePresence initial={false}>
          {isCustomActive === false && <Main key="main" />}
          {isCustomActive === true && <Content key="content" />}
        </AnimatePresence>
      </div>

      <CalculatorDialogs />
    </>
  );
};

const animation: MotionNodeAnimationOptions = {
  initial: {
    opacity: 0,
    translateX: 24,
  },
  animate: {
    opacity: 1,
    translateX: 0,
  },
  exit: {
    opacity: 0,
    translateX: -24,
  },
  transition: {
    duration: 0.3,
    ease: "easeIn",
  },
};

const Main = () => {
  const config = useCalculator((state) => state.config);
  const packs = useCalculator((state) => state.packs);

  return (
    <motion.div className={styles.main} {...animation}>
      <div className={styles.header}>
        <div className={styles.title}>
          <Trans>Payment Period</Trans>
        </div>
        <div className={styles.periods}>
          {config.periods.map((period) => (
            <CalculatorPeriod key={period.id} {...period} />
          ))}
        </div>
      </div>

      <div className={styles.packs}>
        <AnimatePresence initial={false}>
          {packs.map((pack) => (
            <CalculatorPack key={pack.id} pack={pack} />
          ))}
        </AnimatePresence>
      </div>

      <CalculatorPaymentBtn className={styles.btn} />
    </motion.div>
  );
};

const Content = () => {
  return (
    <motion.div className={styles.content} {...animation}>
      <CalculatorCustom className={styles.custom} />

      <CalculatorAside className={styles.aside} />

      <CalculatorPaymentBtn className={styles.btn} />
    </motion.div>
  );
};
